<template>
  <section class="section">
    <div class="columns">
      <div class="column is-6 is-offset-3">
        <h1 class="title">Dashboard</h1>
      </div>
     
    </div>
    <div>
  </div>
  </section>
</template>

<script>


export default {
  name: 'Dashboard',
  data () {
    return {
      allNews: [],
    }
  }
}
</script>
